<template>
    <div class="main-content-narrow">
        <ui-breadcrumb title="Add Funds" :items="navItems"/>
        <div class="block block-rounded block-bordered">
            <el-tabs type="border-card">
                <el-tab-pane @tab-click="loadApp">
                    <span slot="label"> <i class="si si-credit-card"/> Credit Card</span>
                    <div class="container-fluid">
                        <div class="col-md-8 offset-md-2 card-container" v-loading="dropInUiLoading">
                            <div class="pt-2 pb-2">
                                Add funds to your Emalify wallet
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label for="checkout-amount">Amount in KES</label>
                                        <input placeholder="Amount in KES" id="checkout-amount" type="number"
                                               :class="{'is-invalid': validationErrors.amount}"
                                               v-model="checkOutPayload.amount" class="form-control"/>
                                        <div v-if="validationErrors.amount" :class="['invalid-feedback']">
                                            {{validationErrors.amount[0]}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label for="checkout-amount">Currency</label>
                                        <v-select v-model="checkOutPayload.currency" :options="currencies"
                                                  :reduce="option => option.value"/>
                                        <div v-if="validationErrors.currency" :class="['help-block']">
                                            <span class="text-danger">{{validationErrors.currency[0]}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row pb-4" v-if="creditCards.length > 0 && !newCard">
                                <div class="col-sm-12">
                                    <label>Select Credit card to use to complete this transaction</label>
                                </div>
                                <div class="col-md-6 pb-2" v-for="(card, index) in creditCards" :key="index">
                                    <div class="custom-control custom-block custom-control-primary">
                                        <input :id="`cc-${card.id}`" :value="card.id" type="radio"
                                               class="custom-control-input" v-model="checkOutPayload.cardToken">
                                        <label class="custom-control-label" :for="`cc-${card.id}`">
                                        <span class="d-flex align-items-center">
                                            <span class="fa fa-2x fa-credit-card"/>
                                            <span class="ml-2">
                                                <span class="font-w700">{{card.name}}</span>
                                                <span class="d-block font-size-sm text-muted">{{card.pan.replace(/\./gi, 'x')}}</span>
                                            </span>
                                        </span>
                                        </label>
                                        <span class="custom-block-indicator">
                                            <i class="fa fa-check"/>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 pb-2" v-if="validationErrors.cardToken">
                                <span class="help-block text-danger">{{validationErrors.cardToken[0]}}</span>
                            </div>
                            <div v-if="creditCards.length > 0">
                                <div class="custom-control custom-checkbox mb-1">
                                    <input v-model="newCard" @change="addNewCardChanged" type="checkbox"
                                           class="custom-control-input" id="new-card-details-check">
                                    <label class="custom-control-label" for="new-card-details-check">Add new card
                                        details</label>
                                </div>
                            </div>
                            <div class="row pb-4" v-if="newCard">
                                <div class="col-sm-12">
                                    <label>Enter your debit card details to proceed with transaction</label>
                                    <credit-card-field
                                        :activity="processing"
                                        v-model="checkOutPayload.card"
                                        :show-name="true"
                                    />
                                </div>
                                <div class="col-sm-12">

                                </div>
                            </div>
                            <div class="form-group" v-show="!dropInUiLoading">
                                <button @click="initiateCardTransaction" :disabled="processing"
                                        class="btn btn-hero-success float-right">
                                    <i class="si si-credit-card"/>
                                    Process Payment
                                </button>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane>
                    <span slot="label"><i class="el-icon-mobile-phone"/> Lipa na Mpesa</span>
                    <div class="row">
                        <div class="col-lg-3">
                            <strong class="text-muted">
                                Please keep you phone turned on. You will be prompted to enter your M-Pesa Pin
                            </strong>
                        </div>
                        <div class="col-lg-9 col-xl-5">
                            <form method="POST" @submit.prevent="mpesaCheckOut">
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label">Phone Number</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control form-control-alt"
                                               v-model="transaction.phoneNumber" placeholder="Your Phone Number">
                                        <div v-if="validationErrors.phoneNumber" :class="['invalid-feedback']">
                                            {{validationErrors.phoneNumber[0]}}
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label">Amount</label>
                                    <div class="col-sm-8">
                                        <input type="number" class="form-control form-control-alt"
                                               v-model="transaction.amount" placeholder="Amount in KES">
                                        <div v-if="validationErrors.amount" :class="['invalid-feedback']">
                                            {{validationErrors.amount[0]}}
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-sm-8 ml-auto">
                                        <el-button native-type="submit" type="success" icon="el-icon-mobile-phone"
                                                   class="float-right">
                                            Purchase
                                        </el-button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<style lang="scss">
    .card-container {
        min-height: 300px;
    }

    #dropin-container {
        padding-bottom: 1.5em;
    }
</style>

<script>
    import CreditCardField from 'vue-credit-card-field/src/Components/CreditCardField';
    import VueSelect from 'vue-select';

    export default {
        name: "AccountTopUp",
        components: {
            CreditCardField,
            'v-select': VueSelect,
        },
        data() {
            return {
                navItems: ["Account", "Payments"],
                dropInUiLoading: false,
                processing: false,
                creditCards: [],
                transaction: {
                    amount: '',
                    phoneNumber: ''
                },
                validationErrors: {},
                currencies: [
                    {
                        value: 'KES',
                        selected: true,
                        label: 'Kenyan Shilling'
                    }
                ],
                newCard: true,
                checkOutPayload: {
                    currency: '',
                    account: '',
                    amount: '',
                    cardToken: '',
                    card: {}
                }
            }
        },
        mounted() {
            this.getUserCreditCards();
        },
        methods: {
            loadApp() {
                this.dropInUiLoading = true;
                setTimeout(() => {
                    this.dropInUiLoading = false;
                }, 2000);
            },
            addNewCardChanged() {
                this.checkOutPayload.card = '';
            },

            /**
             *
             */
            getUserCreditCards() {
                axios.get('user/billing/credit-cards').then(res => {
                    this.creditCards = res.data.data;
                    if (this.creditCards.length > 0)
                        this.newCard = false;
                });
            },

            initiateCardTransaction() {
                this.checkOutPayload.account = this.$route.params.account;
                this.processing = true;
                let url = this.newCard ? 'payments/accounts/card/checkout' : 'payments/accounts/card/transact'
                axios.post(
                    url,
                    this.checkOutPayload
                ).then(res => {
                    this.$notify({
                        title: 'Payment Successful',
                        message: 'You account was credited successfully',
                        duration: 10000,
                        type: 'success'
                    });
                    this.$router.push(`/accounts/${this.$route.params.account}/overview`)
                }).catch(error => {
                    if (error.response && error.response.status === 422) {
                        this.validationErrors = error.response.data.errors
                    }
                    if (error.response && error.response.status === 400) {
                        this.$notify({
                            message: error.response.data.message,
                            title: 'Payment Failed',
                            type: 'error',
                        });
                    }
                }).finally(() => this.processing = false)
            },

            mpesaCheckOut() {
                this.transaction.account = this.$route.params.account;
                axios.post(
                    `payments/accounts/mpesa/checkout`,
                    this.transaction
                ).then(response => {
                    this.transaction = {
                        amount: '',
                        phoneNumber: ''
                    };
                    this.$notify({
                        title: 'Payment Initiated',
                        message: response.data.message,
                        type: 'success'
                    });
                    this.$router.push(`/accounts/${this.$route.params.account}/overview`)
                }).catch((error) => {
                    this.$notify({
                        title: 'Payment Failed',
                        message: 'An error was encounter while trying to initiate the payment',
                        type: 'error'
                    })
                });
            }
        }
    }
</script>

<style scoped>

</style>
